var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Callback } from 'react-oidc';
import { Route, Switch, withRouter } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { compose, withContext, withHandlers, withProps } from 'recompose';
import './webpackNonce.js';
import App from './App';
import { Authenticator } from './Authenticator';
import LogoutCallback from './LogoutCallback';
import Login from './pages/Login';
import userManager from './userManager';
var RerouteHomeCallback = function (_a) {
    var onSuccess = _a.onSuccess, um = _a.userManager;
    return (React.createElement(Callback, { onSuccess: onSuccess, userManager: um }));
};
var EnhancedRerouteHomeCallback = compose(withRouter, withProps({ userManager: userManager }), withHandlers({
    onSuccess: function (_a) {
        var history = _a.history;
        return function (user) {
            history.push('/graphql');
        };
    },
}))(RerouteHomeCallback);
var EnhancedLogoutCallback = withRouter(LogoutCallback);
function onError(err) {
    if (!sessionStorage.getItem('authnToken')) {
        if (window.location.pathname !== '/login-local') {
            window.location.href = '/login-local';
        }
    }
}
var provide = function (config) { return withContext({ config: PropTypes.object }, function () { return ({ config: config }); }); };
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            config: {
                fetched: false,
                error: false,
                data: null,
            },
        };
        return _this;
    }
    Root.prototype.componentDidMount = function () {
        var _this = this;
        fetch('/graphql/config', { cache: 'default' })
            .then(function (response) {
            if (response.ok) {
                return response.json()
                    .then(function (data) { return ({
                    config: {
                        fetched: true,
                        error: false,
                        data: data,
                    },
                }); });
            }
            else {
                return {
                    config: {
                        fetched: false,
                        error: true,
                        data: null,
                    },
                };
            }
        })
            .then(function (conf) { return _this.setState(function () { return conf; }); })
            .catch(function (conf) { return _this.setState(function () { return conf; }); });
    };
    Root.prototype.render = function () {
        var config = this.state.config;
        return (React.createElement(Switch, null,
            React.createElement(Route, { path: "/graphql/login-callback", component: EnhancedRerouteHomeCallback }),
            React.createElement(Route, { path: "/graphql/logout-callback", component: EnhancedLogoutCallback }),
            config.fetched && !config.error && (React.createElement(Route, { exact: true, path: "/login-local", component: provide(config.data)(Login) })),
            React.createElement(Route, null,
                React.createElement(Authenticator, { userManager: userManager, onError: onError },
                    React.createElement(App, null)))));
    };
    return Root;
}(React.Component));
ReactDOM.render(React.createElement(BrowserRouter, null,
    React.createElement(Root, null)), document.getElementById('app'));
